import {RangeSelectOptions, RangeSelectPlugin} from './rangeSelectPlugin'
import {ThresholdAreaOptions, ThresholdAreaPlugin} from './thresholdAreaPlugin'
export {thresholdAreaPlugin} from './thresholdAreaPlugin'
export {rangeSelectPlugin} from './rangeSelectPlugin'

export type CustomPlugins = Partial<ThresholdAreaPlugin & RangeSelectPlugin>
export type CustomPluginOptions = Partial<ThresholdAreaOptions & RangeSelectOptions>
